module.exports = __webpack_public_path__ + "grip-strength-female.4ceadcd2b7e6405db61b5c6a92cc4881.png";